import { TmBaseComponent } from '@treasury/presentation';
import { userCircleIcon } from '@treasury/presentation/assets/icons';
import '@treasury/presentation/components/tm-icon';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

export interface UserOptionViewModel {
    companyName?: string;
    companyUniqueId?: string;
    digitalId?: string;
    userAlias?: string;
    userCompanyUniqueId: string;
}

export const tagName = 'user-selection';
@customElement(tagName)
export class UserSelection extends TmBaseComponent {
    @property({ type: Array })
    public userOptions: Array<UserOptionViewModel> = [];

    protected render() {
        return html`
            <p class="px-4 pb-4">
                Please select which linked TM User ID you would like to authenticate with:
            </p>
            <table class="user-selector w-full border-collapse">
                <thead>
                    <tr
                        class="bg-page text-xs font-medium text-left border-b border-[--border-color]"
                    >
                        <th class="px-4 py-3">TM User ID</th>
                        <th class="px-4 py-3">Company Name</th>
                    </tr>
                </thead>
                <tbody>
                    ${this.userOptions.map(
                        uo =>
                            html`<tr
                                class="text-sm font-medium border-b border-[--border-color]"
                                @click="${() => this.userSelected(uo)}"
                            >
                                <td class="px-4 py-2">
                                    <div class="flex items-center">
                                        <tm-icon
                                            .icon=${userCircleIcon}
                                            color="var(--icon-color)"
                                        ></tm-icon>
                                        <div class="ml-2">${uo.userAlias}</div>
                                    </div>
                                </td>
                                <td class="px-4 py-2">
                                    <div>${uo.companyName}</div>
                                    <div class="text-xs text-[--secondary-text-color]">
                                        ${uo.companyUniqueId}
                                    </div>
                                </td>
                            </tr>`
                    )}
                </tbody>
            </table>
        `;
    }

    private userSelected(userOption: UserOptionViewModel) {
        this.dispatchEvent(new CustomEvent('selected', { detail: userOption }));
    }

    public static get styles() {
        return [
            css`
                :host {
                    display: block;
                    --icon-color: var(--tm-color-gray-medium);
                }
                :host([theme='dark']) {
                    --icon-color: var(--brand-100);
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: UserSelection;
    }
}
